import { useState, useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import _get from 'lodash/get';

import { AppContext, EMPTY_OBJECT } from 'commons-ui';
import { formatDataAsOrginalLayout, pushNewLayoutInLocal } from 'pages/dashboard/homePageLayout/utils/helper';
import { IViewHomePageLayoutOrder } from 'pages/dashboard/homePageLayout/utils/model';

const useCreate = () => {
	const [showLoader, setShowLoader] = useState(false);
	const { showAlert } = useContext(AppContext);
	const history = useHistory();
	const location = useLocation();
	const rowData = _get(location, ['state', 'rowData']);

	const appendDataToCurrentLayout = (createdData: IViewHomePageLayoutOrder) => {
		setShowLoader(true);
		try {
			pushNewLayoutInLocal(rowData, formatDataAsOrginalLayout(createdData));
			history.goBack();
		} catch (error: any) {
			showAlert(`Error: ${error.response.data.error}`, { type: 'error' });
		} finally {
			setShowLoader(false);
		}
	};

	const handleFormSubmit = (submittedData: IViewHomePageLayoutOrder) => {
		appendDataToCurrentLayout(submittedData);
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	return { data: EMPTY_OBJECT, showLoader, handleFormSubmit, handleFormCancel, setShowLoader };
};

export default useCreate;
